import { useRef, useEffect } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import './SellHeading.css';
import banner from '../../../assets/images/sell-with-us/banner.webp';
import expertIcon from '../../../assets/images/sell-with-us/expert-icon.png';
import authenticityIcon from '../../../assets/images/sell-with-us/authenticity-icon.png';

const cinematicEase = [0.7, 0, 0.3, 1];
const bannerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: cinematicEase },
  },
};
const circleVariants = {
  hidden: { opacity: 0, x: 150 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6, ease: cinematicEase },
  },
};

function SellHeading() {
  const itemsRef = useRef(null);
  const itemsControls = useAnimation();
  const itemsInView = useInView(itemsRef, { once: true });

  useEffect(() => {
    itemsInView
      ? itemsControls.start('visible')
      : itemsControls.start('hidden');
  }, [itemsInView, itemsControls]);

  const scrollToSellForm = () => {
    window.scrollTo({
      top: document.getElementById('sell-form')?.offsetTop,
      behavior: 'smooth',
    });
  };

  return (
    <div className="sell-heading">
      <div className="sell-heading__container" ref={itemsRef}>
        <motion.img
          className="sell-heading__banner"
          src={banner}
          alt=""
          variants={bannerVariants}
          initial="hidden"
          animate={itemsControls}
        />

        <div className="sell-heading__content">
          <h1 className="sell-heading__title">
            Get the Best Value for Your Luxury Watch
            Hassle&#8209;Free&nbsp;&&nbsp;Secure
          </h1>

          <p className="sell-heading__subtitle">
            We specialise in premium, authenticated timepieces by offering
            competitive prices, fast payments, and full transparency.
          </p>

          <ul className="sell-heading__benefits">
            <li className="sell-heading__benefit">
              <img
                className="sell-heading__expert-icon"
                src={expertIcon}
                alt=""
              />
              <p className="sell-heading__benefit-text">Expert Appraisal</p>
            </li>
            <li className="sell-heading__benefit">
              <img
                className="sell-heading__authenticity-icon"
                src={authenticityIcon}
                alt=""
              />
              <p className="sell-heading__benefit-text">
                100% Authenticity Guaranteed
              </p>
            </li>
          </ul>

          <div className="sell-heading__button-container">
            <button
              className="sell-heading__button"
              type="button"
              onClick={scrollToSellForm}
            >
              Get Your Quote
            </button>
          </div>
        </div>

        <motion.div
          className="sell-heading__bg-circle"
          variants={circleVariants}
          initial="hidden"
          animate={itemsControls}
        />
      </div>
    </div>
  );
}

export default SellHeading;
